var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBigTick = function SvgBigTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1486 2368.025 73.106 57.885",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_10",
    transform: "translate(1334.535 2116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_610548_cc",
    transform: "translate(122.345 217.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(29.12 34.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M98.847,34.869A3.044,3.044,0,0,0,96.8,35.963L54.757,85.285l-20.5-19.12a3.045,3.045,0,1,0-4.186,4.423L52.9,91.9a3.044,3.044,0,0,0,4.423-.238L101.463,39.91a3.044,3.044,0,0,0-2.616-5.042Z",
    transform: "translate(-29.12 -34.85)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBigTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bigTick.58d32f2d.svg";
export { ForwardRef as ReactComponent };